import { action } from '@ember/object';
import { cached, tracked } from '@glimmer/tracking';
import { waitFor } from '@ember/test-waiters';
import config from 'uplisting-frontend/config/environment';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { ChannelOptions } from 'uplisting-frontend/pods/connect/listings/mapping/index/controller';

export default class CompSetsController extends BaseController {
  @tracked
  airbnbOfficialConnections!: ModelRegistry['airbnb-official-connection'][];

  @tracked isSubmitting = false;

  @cached
  get haveNoConnections(): boolean {
    return !this.airbnbOfficialConnections.length;
  }

  @cached
  get ctaTranslationKey(): string {
    let base = 'comp_sets.actionable_section.cta.';

    if (this.haveNoConnections) {
      base += 'connect_airbnb';
    } else if (this.currentUser.airdnaRedirectClick) {
      base += 'go_to_airdna';
    } else {
      base += 'optimize_revenue';
    }

    return base;
  }

  @action
  @waitFor
  async handleClick(): Promise<void> {
    if (this.haveNoConnections) {
      await this.router.transitionTo('connect.listings.mapping', {
        queryParams: {
          state: 'comp-sets',
          channel: ChannelOptions.airbnb,
        },
      });

      return;
    }

    if (!this.currentUser.airdnaRedirectClick) {
      this.currentUser.airdnaRedirectClick = true;

      this.isSubmitting = true;

      try {
        await this.currentUser.save();
      } finally {
        this.isSubmitting = false;
      }
    }

    window.open(`${config.airDna.url}/data/my-listing/dashboard`, '_blank');
  }
}
